<div class="h-100 w-100 padt-5 container-scans cursor">
    <div class="vehicle-profile-header d-flex gap5">
        <div class="widget-title">{{widgetData?.title}}</div>
        <!-- <div class="widget-status">Excellent</div> -->
    </div>
    <div *ngIf="isloader" class="h-100 w-100 padt-5">
        <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
      </div>    
    <div class="chart-container" *ngIf="attributeData">
        <app-line-echart [xAxis]="lineChartData?.xAxis" [yAxis]="lineChartData?.yAxis" [series]="lineChartData?.series" [grid]="lineChartData?.grid"></app-line-echart>
    </div>
    <div class="no-data-text d-flex justify-content-center align-items-center" *ngIf="!attributeData && isError">
        Error! No Data!
    </div>
</div>